import React, { useEffect, useState } from 'react';
import './SidebarItem.css';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import AddIcon from '@material-ui/icons/Add';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { Menu, MenuItem } from '@material-ui/core';
import NewShareDialog from '../../Kneura-Web-Whiteboard/IWB/ShareDialog/NewShareDialog/NewShareDialog';

const ITEM_HEIGHT = 48;

const SpaceInfo = ({
  item,
  renameSpace,
  deleteSpace,
  spacesCount,
  menuOptionsClose,
  enterBoardName,
  selectedSpaces,
  setSelectedSpaces,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const boardOptionOpen = Boolean(anchorEl);
  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [shareSpaceId, setShareSpaceId] = useState();
  const [shareSpaceName, setShareSpaceName] = useState();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseboardOptions = () => {
    setAnchorEl(null);
  };

  const openDialog = (spaceData) => {
    setShareSpaceName(spaceData.name);
    setShareSpaceId(spaceData.id);
    setOpenShareDialog(true);
  };

  const closeShareDialog = () => {
    setOpenShareDialog(false);
  };

  useEffect(() => {
    handleCloseboardOptions();
  }, [menuOptionsClose]);

  const toggleSpaces = (space) => {
    if (selectedSpaces.includes(space.id)) {
      setSelectedSpaces(selectedSpaces.filter((ele) => ele !== space.id));
    } else {
      setSelectedSpaces([...selectedSpaces, space.id]);
    }
  };
  return (
    <>
      <div className="sidebar-title">
        <div
          onClick={() => toggleSpaces(item)}
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            flex: 1,
            padding: '0.8em 22px 0.8em 28px',
          }}
        >
          <span className="spaceNameContainer">
            <ArrowRightIcon fontSize="small" className="toggle-btn" />
            <span className="spaceName">{item.name}</span>
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginRight: '22px',
          }}
        >
          <div>
            <MoreHorizIcon
              fontSize="medium"
              style={{
                color: 'rgba(0,0,0,0.6',
                cursor: 'pointer',
                marginRight: '11px',
              }}
              onClick={handleClick}
            />

            <Menu
              //   id={board.name}
              anchorEl={anchorEl}
              keepMounted
              open={boardOptionOpen}
              onClose={handleCloseboardOptions}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '160px',
                },
              }}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              getContentAnchorEl={null}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <MenuItem onClick={() => renameSpace(item)} className="textColor">
                Rename
              </MenuItem>
              <MenuItem
                className="textColor"
                disabled={spacesCount === 1}
                onClick={() => deleteSpace(item)}
              >
                Delete
              </MenuItem>
              <MenuItem className="textColor" onClick={() => openDialog(item)}>
                Share
              </MenuItem>
            </Menu>
          </div>
          <div>
            <AddIcon
              fontSize="medium"
              style={{ color: 'rgba(0,0,0,0.6', cursor: 'pointer' }}
              onClick={enterBoardName}
            />
          </div>
        </div>
      </div>
      <NewShareDialog
        open={openShareDialog}
        closeDialog={closeShareDialog}
        shareSpaceId={shareSpaceId}
        shareSpaceName={shareSpaceName}
      />
    </>
  );
};

export default SpaceInfo;
